const borderRadius = {
  2: "2px",
  3: "3px",
  5: "5px",
  8: "8px",
  10: "10px",
};

export default borderRadius;
